module.exports = __webpack_public_path__ + "3f870c98120abdde7c015b0882a70885.pdf";